
import React from 'react';
import ReactDOM from 'react-dom';
import './BackGroundAnimatorCSS.css';

class BackGroundAnimatorComponent extends React.Component {
    ///api/default/images?$filter=ParentId%20eq%20d5f5fda0-0c49-6a75-a385-ff1400f4265d
    constructor(props) {
        super(props);

        this.state = {
            activeImage: 0,
            images: [],
            mobileImages: [],
        };

        fetch('/api/default/images?$filter=ParentId%20eq%20d5f5fda0-0c49-6a75-a385-ff1400f4265d&$orderby=Ordinal')
            .then(result => result.json())
            .then(j => {
                this.setState(Object.assign(this.state, {images: j.value.filter((item) => item.FolderId !== '9849fea0-0c49-6a75-a385-ff1400f4265d')},
                    {mobileImages: j.value.filter((item) => item.FolderId === '9849fea0-0c49-6a75-a385-ff1400f4265d')}
                    ), () => setInterval(() => {
                    this.setState(Object.assign(this.state, {
                        activeImage: this.rotater()
                    }));
                }, 10000));
            });
    }

    rotater = () => {
        if (this.state.activeImage === this.state.images.length - 1) {
            return 0
        }
        return this.state.activeImage + 1;
    };

    render() {
        return (
            <div style={{
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: '0',
                left: '0',
                zIndex: '0'
            }}>
                {(window.outerWidth < 768 ?  this.state.mobileImages :  this.state.images).map((item, idx) =>
                    <div className="bg-image" key={item.Id} style={this.state.activeImage === idx ? {
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        color: 'transparent',

                        backgroundImage: `url(${process.env.NODE_ENV ==='development' || window.location.port === '8552' ? item.Url :item.Url.includes('https') ? item.Url : item.Url.replace('http','https')})`,
                        backgroundSize: 'cover',
                        zIndex: '0',
                        opacity: '1',
                        transition: 'opacity 2.25s ease-in-out'
                    } : {
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        color: 'transparent',

                        backgroundImage: `url(${process.env.NODE_ENV ==='development' || window.location.port === '8552' ? item.Url :item.Url.includes('https') ? item.Url : item.Url.replace('http','https')})`,
                        backgroundSize: 'cover',
                        zIndex: '0',
                        opacity: '0',
                        transition: 'opacity 2.25s ease-in-out'
                    }}/>
                )}


            </div>
        )

    }
}

let domContainer = document.querySelector('#background');

if (!(domContainer === undefined || domContainer === null) === true ) ReactDOM.render(<BackGroundAnimatorComponent/>, domContainer);
